import DatePicker from 'material-ui/DatePicker';
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import TextField from 'material-ui/TextField';
import React, { Component } from 'react';
import Autosuggest from 'react-autosuggest';
import { connect } from "react-redux";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as actions from '../../actions/actions.jsx';
import s from '../../services/allservices.jsx';
import '../../stylesheet/cardsummary.css';
import '../../stylesheet/tabdesign.css';
// import MultipleSelect from '../../components/common/multiselect.jsx'
// import AuthNavbar from '../navigation/authnavigation.jsx'
import AdminNavbar from '../navigation/adminnavigation.jsx';
import { getClientId, getClientSecret, buildClientHeader } from '../../utils/clientAuth';
import uuidv4 from 'uuid/v4';

const escapeRegexCharacters = str => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');


const getSuggestions = (value, countryState) => {
    const escapedValue = escapeRegexCharacters(value.trim());

    if (escapedValue === '') {
        return [];
    }

    const regex = new RegExp('^' + escapedValue, 'i');

    const suggestions = countryState.filter(country => regex.test(country.name));

    if (suggestions.length === 0) {
        return [
            { name: "No Country Found" }
        ];
    }

    return suggestions;
}
const styles = {
    customWidth: {
        width: 150,
    },
    customWidth1: {
        width: "100%",
        fontSize: "14px",
        cursor: "pointer"

    },
    customWidth2: {
        width: "100%",
        fontSize: "12px",
        fontWeight: "600"

    },
    customWidth3: {
        width: "100%",
        fontSize: "10px !important",
        fontWeight: "600"

    },


    focusStyle: {
        borderTop: "none #333",
        borderLeft: "none #333",
        borderRight: "none #333",
        borderBottom: "2px solid #333"
    },
    focusTextStyle: {
        color: "#333"
    },
    underlineStyle1: {
        borderTop: "none rgb(224, 224, 224)",
        borderLeft: "none rgb(224, 224, 224)",
        borderRight: "none rgb(224, 224, 224)",
        borderBottom: "1px solid #333",
        position: "relative",
        width: "98%"

    },
    buttonStyle: {
        background: "rgba(41, 40, 40, 0.87)",
    },
    floatingLabelStyle: {
        color: "#333",
        fontSize: "14px",
        fontWeight: 600

    },
    floatingLabelFocusStyle: {
        color: "#333"
    },
}

const mapStateToProps = state =>
({
    cardDetailState: state.getCardDetailsReducer.cardDetailState,
    countryState: state.countryReducer.countryState
})
const mapDispatchToProps = dispatch =>
({
    getCardDetails(cardRefNo) {
        dispatch(
            actions.getCardDetailAction(cardRefNo)
        )
    },
    fetchCountryState() {
        dispatch(
            actions.countryAction()
        )
    }
})



class CardDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            address: '',
            address2: '',
            cardNumber: '',
            city: '',
            country: '',
            countryCode: '',
            dateofbirth: '',
            emailId: '',
            firstName: '',
            gender: '',
            homePhoneNumber: '',
            lastName: '',
            mobileNumber: '',
            pincode: '',
            portalCardStatus: '',
            secretAnswer: '',
            secretQuestion: '',
            state: '',
            userName: '',
            cardStatus: '',
            disabled: true,
            disabled1: true,
            correctEmail: true,
            details: true,
            coreectfirstName: true,
            suggestions: [],
            value3: '',

        }

        this.multipleSelect = this.multipleSelect.bind(this)
    }

    // static getDerivedStateFromProps(nextProps, prevState){
    //     
    //     
    //     if(nextProps.cardDetailState!==prevState.cardDetailState){
    //       return { cardDetailState: nextProps.cardDetailState};
    //    }
    //     else return null;
    //  }

    //  componentDidUpdate(prevProps, prevState) {
    //     if(prevProps.cardDetailState!==this.state.cardDetailState){
    //       //Perform some operation here
    //       this.setState({cardDetailState: cardDetailState});
    //     }
    //   }
    componentDidMount() {
        this.props.getCardDetails(localStorage.getItem('cardRefNumber'))
        this.props.fetchCountryState()

        if (this.props.cardDetailState.status === 401) {

            localStorage.clear();
            this.props.history.push('/sessionout')
        }
    }
    onChange1 = (event, { newValue, method }) => {

        if (newValue.name === "") {
            this.setState({
                disabledcontact: false
            })
        }
        else {
            this.setState({
                value3: newValue,
                disabledcontact: true
            })

        }
    };
    getSuggestionValue = suggestion => {

        // if(suggestion.name="No Country Found"){
        //     this.setState({
        //         correctcountry:false
        //     })
        // }
        this.setState({
            country: suggestion.name,
            countryCode: suggestion.alpha3Code
        }, () => {

        })
        return suggestion.name;
    };


    renderSuggestion = suggestion => {
        return suggestion.name || suggestion.name;
    };

    onSuggestionsFetchRequested = ({ value }) => {

        this.setState({
            suggestions: getSuggestions(value, this.props.countryState)
        }, () => {

        });
    };

    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: this.state.country
        });
    };
    onSuggestionSelected = (event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) => {

    };

    componentWillReceiveProps(nextProps) {



        if (nextProps.cardDetailState.status === 200) {
            this.setState({
                address: nextProps.cardDetailState.body.address,
                address2: nextProps.cardDetailState.body.address2,
                cardNumber: nextProps.cardDetailState.body.cardNumber,
                // cardStatus: nextProps.cardDetailState.body.cardStatus,
                city: nextProps.cardDetailState.body.city,
                value3: nextProps.cardDetailState.body.country,
                countryCode: nextProps.cardDetailState.body.countryCode,
                dateofbirth: nextProps.cardDetailState.body.dateofbirth,
                // emailId: nextProps.cardDetailState.body.emailId,
                firstName: nextProps.cardDetailState.body.firstName,
                gender: nextProps.cardDetailState.body.gender,
                homePhoneNumber: nextProps.cardDetailState.body.homePhoneNumber,
                lastName: nextProps.cardDetailState.body.lastName,
                mobileNumber: nextProps.cardDetailState.body.mobileNumber,
                pincode: nextProps.cardDetailState.body.pincode,
                portalCardStatus: nextProps.cardDetailState.body.portalCardStatus,
                secretAnswer: nextProps.cardDetailState.body.secretAnswer,
                secretQuestion: nextProps.cardDetailState.body.secretQuestion,
                state: nextProps.cardDetailState.body.state,
                userName: nextProps.cardDetailState.body.userName,
            })
        }
    }

    handleStatus = (event, index, status) => {
        this.setState({
            cardStatus: status,
            disabled: false
        })
    }

    handleClick = () => {
        document.getElementById('myModal').style.display = 'block'
    }
    handleClose = () => {
        document.getElementById("myModal").style.display = "none"
    }

    handleUpdate = () => {
        let _this = this
        const state = {
            cardReferenceId: localStorage.getItem('cardRefNumber'),
            cardStatus: this.state.cardStatus
        }
        let token = "Token " + localStorage.getItem('token')
        let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
        let traceId = getClientId();
        fetch(plink + s.update_card_status, {
            method: "POST",
            headers: {
                'content-type': 'application/json',
                'Authorization': token,
                'X-Trace-Id': traceId,
                'X-Client-APP': buildClientHeader(),
            },
            body: JSON.stringify(state)

        })
            .then(response => {
                if (response.status === 200 || response.status === 201) {
                    toast.success(response.headers.get('message'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        newestOnTop: true,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    });
                    setTimeout(function () {
                        //_this.props.history.push('/cardsearch')
                        _this.handleClose()
                    }, 3000)

                    // this.setState({
                    //     loader: false
                    // })
                }
                else if (response.status === 401) {
                    localStorage.clear();
                    this.props.history.push('/sessionout')
                }
                else {
                    // this.setState({
                    //     loader: true
                    // })

                    toast.error(response.headers.get('message'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        newestOnTop: true,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    });



                }
            })
    }
    handleEmailId = (e, value) => {
        if (e.target.name === 'emailid' && e.target.value.length !== 0) {
            // eslint-disable-next-line 
            if (/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,40}))$/.test(e.target.value)) {

                this.setState({
                    emailId: value,
                    disabled1: false,
                    correctEmail: true,
                })
            }

            else {
                this.setState({
                    disabled1: true,
                    correctEmail: false,
                })
            }
        }
    }
    handleEmailSubmit = () => {
        document.getElementById('myModal1').style.display = 'block'
    }

    handleUpdateEmail = () => {
        let _this = this
        const state = {
            emailId: this.state.emailId,
            memberId: this.props.cardDetailState.body.memberId

        }
        let token = "Token " + localStorage.getItem('token')
        let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
        let traceId = getClientId();
        fetch(plink + s.update_emailid, {
            method: "POST",
            headers: {
                'content-type': 'application/json',
                'Authorization': token,
                'X-Trace-Id': traceId,
                'X-Client-APP': buildClientHeader(),

            },
            body: JSON.stringify(state)

        })
            .then(response => {
                if (response.status === 200 || response.status === 201) {
                    toast.success(response.headers.get('message'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: true,
                        newestOnTop: true
                    });
                    setTimeout(function () {
                        _this.setState({ details: true })
                        _this.handleClose1()
                        _this.props.getCardDetails(localStorage.getItem('cardRefNumber'))
                    }, 3000)

                    // this.setState({
                    //     loader: false
                    // })
                }
                else if (response.status === 401) {
                    localStorage.clear();
                    this.props.history.push('/sessionout')
                }
                else {
                    // this.setState({
                    //     loader: true
                    // })

                    toast.error(response.headers.get('message'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: true,
                        newestOnTop: true
                    });



                }
            })
    }
    handleClose1 = () => {
        document.getElementById("myModal1").style.display = "none"
    }
    handleEdit = () => {
        this.setState({
            details: false
        })
    }

    handleCancel = () => {
        this.setState({
            details: true
        })
    }
    formatDate = (date) => {
        let day = date.getDate()
        let month = date.getMonth() + 1
        let year = date.getFullYear()
        return `${(day < 10) ? ('0' + day) : day}/${(month < 10) ? ('0' + month) : month}/${year}`
    }
    converDate(date) {
        var mm = date.getMonth() + 1; // getMonth() is zero-based
        var dd = date.getDate();

        return [date.getFullYear(),
        (mm > 9 ? '' : '0') + mm,
        (dd > 9 ? '' : '0') + dd
        ].join('-');
    }

    handleDOB = (event, dob) => {

        var dob1 = new Date(dob);
        var ISostring = dob1.toISOString();
        this.setState({
            dateofbirth: ISostring,
            dobDate: this.converDate(dob)
        })

    }
    handleEditChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }


    multipleSelect(e) {

        e.preventDefault()
        let body = this.props.countryState

        let item = body.find(item => item.name === e.target.value)
        this.props.multiSelect({ name: [e.target.name], value: item })

    }

    updateCardHolderInfo = () => {
        const { cardDetailState } = this.props

        let state = {
            cardNumber: cardDetailState.body.cardNumber,
            cardReferenceId: cardDetailState.body.cardReferenceId,
            memberId: cardDetailState.body.memberId,
            firstName: this.state.firstName || cardDetailState.body.firstName,
            lastName: this.state.lastName || cardDetailState.body.lastName,
            dateofbirth: this.state.dateofbirth || cardDetailState.body.dateofbirth,
            mobileNumber: this.state.mobileNumber || cardDetailState.body.mobileNumber,
            emailId: this.state.emailId || cardDetailState.body.emailId,
            address: this.state.address || cardDetailState.body.address,
            address2: this.state.address2 || cardDetailState.body.address2,
            city: this.state.city || cardDetailState.body.city,
            pincode: this.state.pincode || cardDetailState.body.pincode,
            state: this.state.state || cardDetailState.body.state,
            country: this.state.country || cardDetailState.body.country,
            countryCode: this.state.countryCode || cardDetailState.body.countryCode,
            dobDate: this.state.dobDate || cardDetailState.body.dobDate,

        }
        let token = "Token " + localStorage.getItem('token')
        let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
        let gid = getClientId();
        let traceId = getClientId();

        fetch(plink + s.update_cardholder_info, {
            method: "POST",
            headers: {
                'content-type': 'application/json',
                'Authorization': token,
                'clientId': gid,
                'clientSecret': getClientSecret(gid, this.state.emailId || cardDetailState.body.emailId),
                'X-Trace-Id': traceId,
                'X-Client-APP': buildClientHeader(),
            },
            body: JSON.stringify(state)
        })
            .then(response => {
                if (response.status === 200 || response.status === 201) {
                    toast.success(response.headers.get('message'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: true,
                        newestOnTop: true
                    });
                    this.props.getCardDetails(localStorage.getItem('cardRefNumber'))
                    this.setState({
                        details: true
                    })
                }
                else if (response.status === 401) {
                    localStorage.clear();
                    this.props.history.push('/sessionout')
                }
                else {
                    // this.setState({
                    //     loader: true
                    // })

                    toast.error(response.headers.get('message'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: true,
                        newestOnTop: true
                    });
                }
            })
    }


    render() {

        const { cardDetailState } = this.props
        const { correctEmail, details, value3, suggestions } = this.state
        const inputProps = {
            placeholder: "Country",
            value: value3,
            maxLength: 50,
            onChange: this.onChange1

        };
        return (
            <div>
                <div className="col-sm-12">
                    <AdminNavbar />
                </div>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnVisibilityChange
                    draggable
                    pauseOnHover
                />
                <div className="col-sm-12" style={{ marginTop: "100px" }}>
                    <span style={{ fontSize: "25px", fontWeight: "400" }}>
                        Card Search Results
                    </span>
                </div>
                <div className="col-sm-11" style={{ marginLeft: "20px", marginTop: "20px" }}>
                    <div className="col-sm-12" style={{ padding: "0px" }}>
                        <div className="row">
                            <div className="col-sm-5">
                                {(cardDetailState.status === 200) ?
                                    <div className="col-sm-12" style={{ padding: "0px" }}>
                                        <div className="col-sm-12">
                                            <table className="table table-active table-striped" style={{ marginLeft: "20px", marginTop: "15px" }}>
                                                <thead className="thead-dark">
                                                    <tr style={{ fontSize: "11px" }}>
                                                        <th scope="col" colspan="2" style={{ padding: "10px", textAlign: "center", fontSize: "15px" }}>Cardholder Information <i className="fa fa-edit" onClick={this.handleEdit.bind(this)} style={{ marginRight: "10px", fontSize: "15px", fontWeight: "bold", cursor: "pointer", float: "right", marginTop: "4px" }} title="Edit Cardholder Information">  </i> </th>
                                                        {/* <th style={{ padding: "5px 0px 10px 20px", }} > </th> */}
                                                    </tr>

                                                </thead>

                                                <tbody id="myTable" style={{ fontSize: "15px" }}>
                                                    <tr>
                                                        <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>User Name:</td>
                                                        <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {cardDetailState.body.userName}</td>

                                                    </tr>
                                                    <tr>
                                                        <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Card Number:</td>
                                                        <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {cardDetailState.body.cardNumber}</td>

                                                    </tr>
                                                    <tr>
                                                        <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Card Ref. Number:</td>
                                                        <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {cardDetailState.body.cardReferenceId}</td>

                                                    </tr>
                                                    {details ?
                                                        <tr>
                                                            <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>First Name:</td>
                                                            <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {cardDetailState.body.firstName}</td>

                                                        </tr>
                                                        :
                                                        <tr>
                                                            <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>First Name:</td>
                                                            <TextField
                                                                id="standard-bare"
                                                                className="input-width required"
                                                                name="firstName"
                                                                defaultValue={cardDetailState.body.firstName}
                                                                onChange={this.handleEditChange.bind(this)}
                                                                margin="normal"
                                                                style={styles.customWidth2}
                                                                underlineStyle={styles.underlineStyle1}
                                                            />
                                                        </tr>}

                                                    {details ?
                                                        <tr>
                                                            <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Last Name:</td>
                                                            <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}>{cardDetailState.body.lastName}</td>

                                                        </tr>
                                                        :
                                                        <tr>
                                                            <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Last Name:</td>
                                                            <TextField
                                                                id="standard-bare"
                                                                className="input-width required"
                                                                name="lastName"
                                                                defaultValue={cardDetailState.body.lastName}
                                                                onChange={this.handleEditChange.bind(this)}
                                                                margin="normal"
                                                                style={styles.customWidth2}
                                                                underlineStyle={styles.underlineStyle1}
                                                            />
                                                        </tr>}

                                                    {details ?
                                                        <tr>
                                                            <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Date of Birth:</td>
                                                            <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {cardDetailState.body.dateofbirth}</td>

                                                        </tr> :
                                                        <tr>
                                                            <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Date of Birth:</td>

                                                            <DatePicker
                                                                // floatingLabelText="Date Of Birth"
                                                                textFieldStyle={{ width: "100%", fontSize: "12px", fontWeight: "600" }}
                                                                defaultDate={new Date(cardDetailState.body.dobDate)}
                                                                onChange={this.handleDOB.bind(this)}
                                                                formatDate={this.formatDate}
                                                                maxDate={new Date()}
                                                                underlineStyle={styles.underlineStyle1}
                                                            // style={styles.customWidth3}
                                                            />
                                                        </tr>}
                                                    {details ?
                                                        <tr>
                                                            <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Address 1:</td>
                                                            <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {cardDetailState.body.address}</td>

                                                        </tr>
                                                        :
                                                        <tr>
                                                            <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Address 1:</td>
                                                            <TextField
                                                                id="standard-bare"
                                                                className="input-width required"
                                                                name="address"
                                                                defaultValue={cardDetailState.body.address}
                                                                margin="normal"
                                                                onChange={this.handleEditChange.bind(this)}
                                                                underlineStyle={styles.underlineStyle1}
                                                                style={styles.customWidth2}
                                                            />
                                                        </tr>
                                                    }
                                                    {details ?
                                                        <tr>
                                                            <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Address 2:</td>
                                                            <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}>{cardDetailState.body.address2}</td>

                                                        </tr>
                                                        :
                                                        <tr>
                                                            <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Address 2:</td>
                                                            <TextField
                                                                id="standard-bare"
                                                                className="input-width required"
                                                                defaultValue={cardDetailState.body.address2}
                                                                margin="normal"
                                                                name="address2"
                                                                onChange={this.handleEditChange.bind(this)}
                                                                underlineStyle={styles.underlineStyle1}
                                                                style={styles.customWidth2}
                                                            />
                                                        </tr>
                                                    }
                                                    {details ?
                                                        <tr>
                                                            <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>City:</td>
                                                            <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {cardDetailState.body.city}</td>

                                                        </tr> :
                                                        <tr>
                                                            <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>City:</td>
                                                            <TextField
                                                                id="standard-bare"
                                                                className="input-width required"
                                                                defaultValue={cardDetailState.body.city}
                                                                margin="normal"
                                                                name="city"
                                                                onChange={this.handleEditChange.bind(this)}
                                                                underlineStyle={styles.underlineStyle1}
                                                                style={styles.customWidth2}
                                                            />
                                                        </tr>
                                                    }
                                                    {details ?
                                                        <tr>
                                                            <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>State/Province:</td>
                                                            <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {cardDetailState.body.state}</td>

                                                        </tr> :
                                                        <tr>
                                                            <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>State/Province:</td>
                                                            <TextField
                                                                id="standard-bare"
                                                                className="input-width required"
                                                                defaultValue={cardDetailState.body.state}
                                                                margin="normal"
                                                                name="state"
                                                                onChange={this.handleEditChange.bind(this)}
                                                                underlineStyle={styles.underlineStyle1}
                                                                style={styles.customWidth2}
                                                            />
                                                        </tr>
                                                    }
                                                    {details ?
                                                        <tr>
                                                            <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Zip/Postal Code:</td>
                                                            <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {cardDetailState.body.pincode}</td>

                                                        </tr>
                                                        :
                                                        <tr>
                                                            <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Zip/Postal Code:</td>
                                                            <TextField
                                                                id="standard-bare"
                                                                className="input-width required"
                                                                defaultValue={cardDetailState.body.pincode}
                                                                margin="normal"
                                                                onChange={this.handleEditChange.bind(this)}
                                                                underlineStyle={styles.underlineStyle1}
                                                                style={styles.customWidth2}
                                                                type="text"
                                                                name="pincode"
                                                            />
                                                        </tr>
                                                    }
                                                    {details ?
                                                        <tr>
                                                            <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Country:</td>
                                                            <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {cardDetailState.body.country}</td>

                                                        </tr> :
                                                        <tr>
                                                            <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Country:</td>
                                                            {/* <MultipleSelect
                                                        image
                                                        name="country"
                                                        items={this.state.countryState}
                                                        kiey="alpha3Code"
                                                        value="alpha3Code"
                                                        default={ this.state.countryName }                                                     
                                                        description="name"
                                                        flag="flag"
                                                        searchKey="name"
                                                        selectValue={this.handlemcountryempty.bind(this)} 
                                                
                                                  /> */}
                                                            <Autosuggest

                                                                suggestions={suggestions}
                                                                onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                                                                onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                                                                getSuggestionValue={this.getSuggestionValue}
                                                                renderSuggestion={this.renderSuggestion}
                                                                onSuggestionSelected={this.onSuggestionSelected}
                                                                inputProps={inputProps}
                                                            // errorText={correctcountry ? null : "Not a valid name"}
                                                            />
                                                        </tr>
                                                    }

                                                    <tr>
                                                        <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Secret Question:</td>
                                                        <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {cardDetailState.body.secretQuestion}</td>

                                                    </tr>
                                                    <tr>
                                                        <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Answer:</td>
                                                        <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {cardDetailState.body.secretAnswer}</td>

                                                    </tr>
                                                    <tr>
                                                        <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Home Phone Number:</td>
                                                        <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {cardDetailState.body.homePhoneNumber}</td>

                                                    </tr>
                                                    {details ?
                                                        <tr>
                                                            <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Mobile Number:</td>
                                                            <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {cardDetailState.body.mobileNumber}</td>

                                                        </tr> :
                                                        <tr>
                                                            <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Mobile Number:</td>
                                                            <TextField
                                                                id="standard-bare"
                                                                className="input-width required"
                                                                defaultValue={cardDetailState.body.mobileNumber}
                                                                margin="normal"
                                                                onChange={this.handleEditChange.bind(this)}
                                                                underlineStyle={styles.underlineStyle1}
                                                                style={styles.customWidth2}
                                                                type="text"
                                                                name="mobileNumber"
                                                            />
                                                        </tr>
                                                    }
                                                    {details ?
                                                        <tr>
                                                            <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Email:</td>
                                                            <td style={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}> {cardDetailState.body.emailId}</td>

                                                        </tr> :
                                                        <tr>
                                                            <td style={{ textAlign: "right", padding: "10px 60px 10px 0px", fontSize: "12px", fontWeight: "600", color: "#50504a" }}>Email:</td>
                                                            <TextField
                                                                id="standard-bare"
                                                                className="input-width required"
                                                                defaultValue={cardDetailState.body.emailId}
                                                                margin="normal"
                                                                onChange={this.handleEditChange.bind(this)}
                                                                underlineStyle={styles.underlineStyle1}
                                                                style={styles.customWidth2}
                                                                name="emailId"
                                                            />
                                                        </tr>
                                                    }



                                                </tbody>


                                            </table>
                                        </div>
                                        {details ?
                                            null :
                                            <div className="col-sm-12">
                                                <div className="row">
                                                    <div className="col-sm-3 offset-3" style={{ marginTop: "7px", marginBottom: "10px", padding: "0px 0px 15px 35px" }}>
                                                        <RaisedButton
                                                            label="Cancel"
                                                            className="btn-std"
                                                            backgroundColor="#FFCE39"
                                                            labelColor="#115876"
                                                            onClick={this.handleCancel.bind(this)}
                                                        />
                                                    </div>
                                                    <div className="col-sm-3 " style={{ marginTop: "7px", marginBottom: "10px", padding: "0px 0px 15px 35px" }}>
                                                        <RaisedButton
                                                            label="Update"
                                                            className="btn-std"
                                                            backgroundColor="#FFCE39"
                                                            labelColor="#115876"
                                                            onClick={this.updateCardHolderInfo.bind(this)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                    :
                                    <div></div>

                                }
                            </div>
                            <div className="offset-1 col-sm-4" style={{ padding: "0px 0px 4px 0px", height: "100%", marginTop: "15px" }}>
                                <div className="col-sm-12" style={{ padding: "0px", boxShadow: "0px 1px 3px 2px rgba(0,0,0,0.2)", }}>
                                    <div className="col-sm-12" style={{ background: "#eeeeee", padding: "0px", minHeight: "43px", textAlign: "center", backgroundColor: "#212529", color: "#fff" }}>
                                        <div style={{ padding: "10px", fontSize: "15px", fontWeight: "600" }}>Update Card Status</div>
                                    </div>
                                    <div className="col-sm-12" style={{ marginTop: "10px" }}>
                                        <div className="row">
                                            <div className="col-sm-7" style={{ textAlign: "right" }}>
                                                <span>
                                                    Current Card Status:
                                                </span>
                                            </div>
                                            {(cardDetailState.status === 200) ?
                                                <div className="col-sm-4" style={{ fontWeight: "600", fontSize: "15px" }}>
                                                    <span>
                                                        {cardDetailState.body.portalCardStatus}
                                                    </span>
                                                </div>
                                                :
                                                <div></div>
                                            }
                                        </div>
                                    </div>
                                    <div className="col-sm-12" style={{ marginTop: "5px" }}>
                                        <div className="row">
                                            <div className="col-sm-7" style={{ textAlign: "right" }}>
                                                <span>
                                                    Card Status at Processor:
                                                </span>
                                            </div>
                                            {(cardDetailState.status === 200) ?
                                                <div className="col-sm-4" style={{ fontWeight: "600", fontSize: "15px" }}>
                                                    <span>
                                                        {cardDetailState.body.cardStatus}
                                                    </span>
                                                </div>
                                                :
                                                <div></div>
                                            }
                                        </div>
                                    </div>
                                    <div className="offset-2 col-sm-7">
                                        <SelectField
                                            floatingLabelText="Update Card Status"
                                            name="cardStatus"
                                            onChange={this.handleStatus.bind(this)}
                                            floatingLabelStyle={styles.floatingLabelStyle}
                                            style={styles.customWidth1}
                                            value={this.state.cardStatus}
                                        >
                                            <MenuItem className="menuitem" value="B" primaryText="Open" />
                                            <MenuItem className="menuitem" value="F" primaryText="Closed" />
                                        </SelectField>
                                    </div>
                                    <div className="col-sm-8 offset-4" style={{ marginTop: "7px", marginBottom: "10px", padding: "0px 0px 15px 35px" }}>
                                        <RaisedButton
                                            label="Submit"
                                            className="btn-std"
                                            backgroundColor="#FFCE39"
                                            labelColor="#115876"
                                            disabled={this.state.disabled}
                                            onClick={this.handleClick.bind(this)}
                                        />
                                    </div>
                                </div>
                                <div className="col-sm-12" style={{ padding: "0px", boxShadow: "0px 1px 3px 2px rgba(0,0,0,0.2)", marginTop: "40px" }}>
                                    <div className="col-sm-12" style={{ background: "#eeeeee", padding: "0px", minHeight: "43px", textAlign: "center", backgroundColor: "#212529", color: "#fff" }}>
                                        <div style={{ padding: "10px", fontSize: "15px", fontWeight: "600" }}>Update Email Address</div>
                                    </div>
                                    <div className="col-sm-12" style={{ marginTop: "10px" }}>
                                        <div className="row">
                                            <div className="col-sm-4" style={{ textAlign: "right", marginLeft: "30px" }}>
                                                <span>
                                                    Current Email Address:
                                                </span>
                                            </div>
                                            {(cardDetailState.status === 200) ?
                                                <div className="col-sm-7" style={{ fontWeight: "600", fontSize: "15px" }}>
                                                    <span>
                                                        {cardDetailState.body.emailId}
                                                    </span>
                                                </div>
                                                :
                                                <div></div>
                                            }
                                        </div>
                                    </div>

                                    <div className="offset-2 col-sm-7">
                                        <TextField
                                            hintText="Start Typing"
                                            floatingLabelText="Email Address"
                                            type="text"
                                            name="emailid"
                                            className="input-width"
                                            maxLength="50"
                                            onChange={this.handleEmailId}
                                            underlineFocusStyle={styles.focusStyle}
                                            floatingLabelFocusStyle={styles.focusTextStyle}
                                            floatingLabelStyle={styles.floatingLabelStyle}
                                            errorText={correctEmail ? null : "Invalid Email"}

                                        />
                                    </div>
                                    <div className="col-sm-8 offset-4" style={{ marginTop: "7px", marginBottom: "10px", padding: "0px 0px 15px 35px" }}>
                                        <RaisedButton
                                            label="Submit"
                                            className="btn-std"
                                            backgroundColor="#FFCE39"
                                            labelColor="#115876"
                                            disabled={this.state.disabled1}
                                            onClick={this.handleEmailSubmit.bind(this)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div className="col-sm-12 modal-for-login flowmodal" id="myModal" style={{ display: "none" }}>
                    <div className="modal-content col-sm-4" style={{ background: "rgb(214, 70, 84)" }}>
                        <div className="modal-header" style={{ borderBottom: "none", height: "45px" }}>
                            <div className="col-sm-12" style={{ marginTop: "-7px" }}>
                                <div className="row">
                                    <div className="col-sm-6" style={{ fontSize: "19px", fontWeight: "600", color: "rgb(255, 255, 255)" }}>
                                        <span>Update Card Status</span>
                                    </div>
                                    <div className="offset-4 col-sm-2" style={{ float: "right" }}>
                                        <button type="button" className="close" data-dismiss="modal" style={{ marginTop: "-19px" }} onClick={this.handleClose.bind(this)} aria-label="Close">
                                            <span aria-hidden="true" style={{ color: "#fff", fontSize: "22px" }}>&times;</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="modal-body text-center" style={{ backgroundColor: "#fff" }}>
                            <div className="col-sm-12" >
                                <i className="fa fa-question fa-4x mb-3 animated rotateIn" style={{ color: "rgb(214, 70, 84)" }}></i>
                            </div>
                            <div className="col-sm-12" style={{ fontSize: "20px" }}>
                                <span>Are you sure, you want to update card status?</span>
                            </div>
                            <div className="col-sm-12" >
                                <div className="row">
                                    <div className="col-sm-3 offset-3" style={{ padding: "0px", textAlign: "right" }}>
                                        <button type="button" className="btn btn-outline-danger waves-effect" data-dismiss="modal" style={{ fontSize: "13px", fontWeight: "bold", marginTop: "8px", border: "2px solid rgb(214, 70, 84)", padding: "3px 15px" }}
                                            onClick={this.handleClose.bind(this)}
                                            aria-label="Close">
                                            Cancel
                                        </button>
                                    </div>
                                    <div className="col-sm-3" style={{ textAlign: "left" }}>
                                        <button type="button" className="btn btn-outline-danger waves-effect" data-dismiss="modal" style={{ fontSize: "13px", fontWeight: "bold", marginTop: "8px", border: "2px solid rgb(214, 70, 84)", padding: "3px 15px" }}
                                            onClick={this.handleUpdate.bind(this)}
                                            aria-label="Close">
                                            OK
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-sm-12 modal-for-login flowmodal" id="myModal1" style={{ display: "none" }}>
                    <div className="modal-content col-sm-4" style={{ background: "rgb(214, 70, 84)" }}>
                        <div className="modal-header" style={{ borderBottom: "none", height: "45px" }}>
                            <div className="col-sm-12" style={{ marginTop: "-7px" }}>
                                <div className="row">
                                    <div className="col-sm-6" style={{ fontSize: "19px", fontWeight: "600", color: "rgb(255, 255, 255)" }}>
                                        <span>Update Email Address</span>
                                    </div>
                                    <div className="offset-4 col-sm-2" style={{ float: "right" }}>
                                        <button type="button" className="close" data-dismiss="modal" style={{ marginTop: "-19px" }} onClick={this.handleClose1.bind(this)} aria-label="Close">
                                            <span aria-hidden="true" style={{ color: "#fff", fontSize: "22px" }}>&times;</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="modal-body text-center" style={{ backgroundColor: "#fff" }}>
                            <div className="col-sm-12" >
                                <i className="fa fa-question fa-4x mb-3 animated rotateIn" style={{ color: "rgb(214, 70, 84)" }}></i>
                            </div>
                            <div className="col-sm-12" style={{ fontSize: "20px" }}>
                                <span>Are you sure, you want to update Email Address?</span>
                            </div>
                            <div className="col-sm-12" >
                                <div className="row">
                                    <div className="col-sm-3 offset-3" style={{ padding: "0px", textAlign: "right" }}>
                                        <button type="button" className="btn btn-outline-danger waves-effect" data-dismiss="modal" style={{ fontSize: "13px", fontWeight: "bold", marginTop: "8px", border: "2px solid rgb(214, 70, 84)", padding: "3px 15px" }}
                                            onClick={this.handleClose1.bind(this)}
                                            aria-label="Close">
                                            Cancel
                                        </button>
                                    </div>
                                    <div className="col-sm-3" style={{ textAlign: "left" }}>
                                        <button type="button" className="btn btn-outline-danger waves-effect" data-dismiss="modal" style={{ fontSize: "13px", fontWeight: "bold", marginTop: "8px", border: "2px solid rgb(214, 70, 84)", padding: "3px 15px" }}
                                            onClick={this.handleUpdateEmail.bind(this)}
                                            aria-label="Close">
                                            OK
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CardDetails);


// WEBPACK FOOTER //
// ./src/components/adminuser/carddetails.jsx